import { useMemo } from "react";

import { useGetCategoryById } from "../../categories/apis";
import { AttributeTypes } from "../../categories/constants/enums";
import {
  getCategoryAttributeByName,
  getCategoryAttributesByType
} from "../helpers";

const useProductDetailsCategory = (categoryId: string) => {
  const { category, isLoading } = useGetCategoryById(categoryId);
  const sizeAttribute = useMemo(
    () => getCategoryAttributeByName(category, "Size"),
    [category]
  );

  const colorAttribute = useMemo(
    () => getCategoryAttributeByName(category, "Color"),
    [category]
  );

  const productDetailsAttributes = useMemo(
    () => getCategoryAttributesByType(category, AttributeTypes.Related),
    [category]
  );

  const additionalAttributes = useMemo(
    () => getCategoryAttributesByType(category, AttributeTypes.Additional),
    [category]
  );

  return {
    category,
    categoryAttributes:
      sizeAttribute && colorAttribute
        ? {
            sizeAttribute,
            colorAttribute,
            productDetailsAttributes,
            additionalAttributes
          }
        : null,
    isLoading
  };
};

export default useProductDetailsCategory;
